<template>
    <footer class="text-white">
        <div class="grid lg:grid-cols-12">
            <!-- Left column: Logo + main nav -->
            <div class="bg-black lg:col-span-3 p-8 lg:p-12 flex flex-col items-center lg:items-start">
                <a href="/">
                    <img src="/images/logos/camaq_white.webp" alt="CAMAQ" class="h-16 w-40 object-contain" />
                </a>

                <nav class="mt-8 flex flex-row flex-wrap justify-center gap-4 lg:flex-col lg:gap-2">
                    <InertiaLink href="/formations" class="text-sm text-gray-300 hover:text-white">Formations</InertiaLink>
                    <InertiaLink :href="$page.props.locale == 'fr' ? '/emplois' : '/en/job-opportunities'" class="text-sm text-gray-300 hover:text-white">{{ $t('Job opportunities') }}</InertiaLink>
                    <InertiaLink :href="$page.props.locale == 'fr' ? '/stages' : '/en/internships'" class="text-sm text-gray-300 hover:text-white">{{ $t('Internships') }}</InertiaLink>
                    <InertiaLink :href="$page.props.locale == 'fr' ? '/evenements' : '/en/events'" class="text-sm text-gray-300 hover:text-white">{{ $t('Events') }}</InertiaLink>
                    <a href="https://camaq.org/contact/" target="_blank" rel="noopener" class="text-sm text-gray-300 hover:text-white">Contact</a>
                </nav>
            </div>

            <!-- Right column: Links grid -->
            <div class="lg:col-span-9 p-8 lg:p-12" style="background: linear-gradient(260deg, rgb(44, 169, 223) 3%, rgb(1, 79, 121) 100%)">
                <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
                    <!-- À propos -->
                    <div>
                        <h5 class="text-xs font-semibold uppercase tracking-wider mb-4 text-white/70">{{ $t('About') }}</h5>
                        <nav class="flex flex-col space-y-2">
                            <a href="https://camaq.org/?page_id=190" target="_blank" rel="noopener" class="text-sm hover:underline">{{ $t('Who we are') }}</a>
                            <a href="https://camaq.org/administrateurs/" target="_blank" rel="noopener" class="text-sm hover:underline">{{ $t('Board members') }}</a>
                            <a href="https://camaq.org/partenaires/" target="_blank" rel="noopener" class="text-sm hover:underline">{{ $t('Partners') }}</a>
                        </nav>
                    </div>

                    <!-- Secteurs -->
                    <div>
                        <h5 class="text-xs font-semibold uppercase tracking-wider mb-4 text-white/70">{{ $t('Sectors') }}</h5>
                        <nav class="flex flex-col space-y-2">
                            <a href="https://camaq.org/industrie/" target="_blank" rel="noopener" class="text-sm hover:underline">{{ $t('The industry') }}</a>
                            <a href="https://camaq.org/metiers-vedettes/" target="_blank" rel="noopener" class="text-sm hover:underline">{{ $t('Featured trades') }}</a>
                        </nav>
                    </div>

                    <!-- Formations -->
                    <div>
                        <h5 class="text-xs font-semibold uppercase tracking-wider mb-4 text-white/70">Formations</h5>
                        <nav class="flex flex-col space-y-2">
                            <a href="https://camaq.org/formations-vedettes/" target="_blank" rel="noopener" class="text-sm hover:underline">{{ $t('Featured training') }}</a>
                            <a href="https://camaq.org/formations-camaq/" target="_blank" rel="noopener" class="text-sm hover:underline">{{ $t('CAMAQ training') }}</a>
                            <a href="https://camaq.org/formations-ate/" target="_blank" rel="noopener" class="text-sm hover:underline">{{ $t('COUD Training') }}</a>
                        </nav>
                    </div>

                    <!-- Publications -->
                    <div>
                        <h5 class="text-xs font-semibold uppercase tracking-wider mb-4 text-white/70">Publications</h5>
                        <nav class="flex flex-col space-y-2">
                            <a href="https://camaq.org/diagnostic-sectoriel/" target="_blank" rel="noopener" class="text-sm hover:underline">{{ $t('Sector diagnosis') }}</a>
                            <a href="https://camaq.org/enquete-salariale/" target="_blank" rel="noopener" class="text-sm hover:underline">{{ $t('Salary survey') }}</a>
                            <a href="https://camaq.org/rapports-annuels/" target="_blank" rel="noopener" class="text-sm hover:underline">{{ $t('Annual reports') }}</a>
                        </nav>
                    </div>

                    <!-- Coordonnées -->
                    <div>
                        <h5 class="text-xs font-semibold uppercase tracking-wider mb-4 text-white/70">{{ $t('Contact info') }}</h5>
                        <nav class="flex flex-col space-y-2">
                            <a href="tel:514-596-3311" class="text-sm hover:underline">514-596-3311</a>
                            <a href="mailto:info@camaq.org" class="text-sm hover:underline">info@camaq.org</a>
                            <p class="text-sm">5300 Rue Chauveau<br>Montréal, Québec H1N 3V7</p>
                        </nav>
                    </div>

                    <!-- Informations légales -->
                    <div>
                        <h5 class="text-xs font-semibold uppercase tracking-wider mb-4 text-white/70">{{ $t('Legal') }}</h5>
                        <nav class="flex flex-col space-y-2">
                            <a href="https://camaq.org/termes-et-conditions/" target="_blank" rel="noopener" class="text-sm hover:underline">{{ $t('Terms and conditions') }}</a>
                            <a href="https://camaq.org/politique-de-confidentialite/" target="_blank" rel="noopener" class="text-sm hover:underline">{{ $t('Confidentiality policy') }}</a>
                            <button @click.prevent="showCookieConsent" class="text-sm text-left hover:underline">{{ $t('Cookie policy') }}</button>
                        </nav>
                    </div>

                    <!-- Infolettre -->
                    <div class="col-span-2 md:col-span-1 lg:col-span-2">
                        <h5 class="text-xs font-semibold uppercase tracking-wider mb-4 text-white/70">{{ $t('Newsletter') }}</h5>
                        <p class="text-sm mb-4">{{ $t('Subscribe to our newsletter to stay up to date with the latest news and upcoming events!') }}</p>
                        <a href="https://app.cyberimpact.com/clients/33599/subscribe-forms/D2E42874-2196-40ED-BFFD-8999639C04EC" target="_blank" rel="noopener" class="inline-block rounded bg-white text-primary px-4 py-2 text-sm font-semibold hover:bg-gray-100">
                            {{ $t('Sign me up') }}
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bottom bar -->
        <div class="bg-white text-gray-600 py-4 px-8">
            <div class="container mx-auto flex flex-col md:flex-row items-center justify-between text-sm">
                <p>&copy; {{ date }}, CAMAQ</p>

                <div class="flex items-center space-x-4 mt-4 md:mt-0">
                    <a href="https://www.linkedin.com/company/camaq" target="_blank" rel="noopener" class="text-gray-500 hover:text-gray-800">
                        <IconBrandLinkedin :size="20" />
                    </a>
                    <a href="https://www.facebook.com/csmoCAMAQ" target="_blank" rel="noopener" class="text-gray-500 hover:text-gray-800">
                        <IconBrandFacebook :size="20" />
                    </a>
                    <a href="https://www.youtube.com/@camaq" target="_blank" rel="noopener" class="text-gray-500 hover:text-gray-800">
                        <IconBrandYoutube :size="20" />
                    </a>
                    <a href="https://www.instagram.com/camaq_aero/" target="_blank" rel="noopener" class="text-gray-500 hover:text-gray-800">
                        <IconBrandInstagram :size="20" />
                    </a>
                    <a href="https://x.com/CAMAQ_aero" target="_blank" rel="noopener" class="text-gray-500 hover:text-gray-800">
                        <IconBrandX :size="20" />
                    </a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup>
    import { computed } from 'vue';
    import { IconBrandFacebook, IconBrandInstagram, IconBrandLinkedin, IconBrandYoutube, IconBrandX } from '@tabler/icons-vue';

    const date = computed(() => new Date().getFullYear());

    function showCookieConsent() {
        window.bus.emit('show-cookie-consent');
    }
</script>
